require('../styles.css');
"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);

// src/icons/monochrome/IconEyeOpened.tsx
var IconEyeOpened_exports = {};
__export(IconEyeOpened_exports, {
  default: () => IconEyeOpened_default
});
module.exports = __toCommonJS(IconEyeOpened_exports);

// src/assets/monochrome/eyeOpened.svg
var import_jsx_runtime = require("react/jsx-runtime");
var SvgEyeOpened = (props) => /* @__PURE__ */ (0, import_jsx_runtime.jsx)("svg", { width: 20, height: 20, viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props, children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)("path", { d: "M18.677 9.625C16.9101 5.22813 13.5863 2.5 10 2.5C6.41375 2.5 3.08991 5.22813 1.32302 9.625C1.27486 9.74328 1.25 9.87095 1.25 10C1.25 10.1291 1.27486 10.2567 1.32302 10.375C3.08991 14.7719 6.41375 17.5 10 17.5C13.5863 17.5 16.9101 14.7719 18.677 10.375C18.7251 10.2567 18.75 10.1291 18.75 10C18.75 9.87095 18.7251 9.74328 18.677 9.625ZM10 15.625C7.22722 15.625 4.60313 13.4781 3.08991 10C4.60313 6.52187 7.22722 4.375 10 4.375C12.7728 4.375 15.3969 6.52187 16.9101 10C15.3969 13.4781 12.7728 15.625 10 15.625ZM10 6.25C9.30801 6.25 8.63155 6.46993 8.05618 6.88199C7.48081 7.29404 7.03236 7.87971 6.76755 8.56494C6.50273 9.25016 6.43345 10.0042 6.56845 10.7316C6.70345 11.459 7.03667 12.1272 7.52599 12.6517C8.0153 13.1761 8.63872 13.5333 9.31742 13.6779C9.99612 13.8226 10.6996 13.7484 11.3389 13.4645C11.9782 13.1807 12.5247 12.7001 12.9091 12.0834C13.2936 11.4667 13.4988 10.7417 13.4988 10C13.4988 9.00544 13.1302 8.05161 12.474 7.34835C11.8179 6.64509 10.9279 6.25 10 6.25ZM10 11.875C9.654 11.875 9.31578 11.765 9.02809 11.559C8.74041 11.353 8.51618 11.0601 8.38377 10.7175C8.25137 10.3749 8.21672 9.99792 8.28422 9.63421C8.35172 9.27049 8.51834 8.9364 8.76299 8.67418C9.00765 8.41195 9.31936 8.23337 9.65871 8.16103C9.99806 8.08868 10.3498 8.12581 10.6695 8.26773C10.9891 8.40964 11.2623 8.64996 11.4546 8.95831C11.6468 9.26665 11.7494 9.62916 11.7494 10C11.7494 10.4973 11.5651 10.9742 11.237 11.3258C10.9089 11.6775 10.464 11.875 10 11.875Z", fill: "#676F7E" }) });
var eyeOpened_default = SvgEyeOpened;

// src/Wrappers/helpers.ts
var getIconBaseCssVariables = ({
  size,
  rotate,
  transitionDuration
}) => {
  return {
    "--icon-size": size ? `${size}px` : "100%",
    "--icon-rotate": rotate ? `${rotate}deg` : "0deg",
    // Browser cannot handle multiple transitions on the same property if another variable (e.g. --transition-duration)
    // is defined on another element.
    "--icon-transition-fill": transitionDuration ? `fill ${transitionDuration} ease` : "none",
    "--icon-transition-transform": transitionDuration ? `transform ${transitionDuration} ease` : "none"
  };
};
var getIconColoringCssVariables = ({
  state,
  color,
  activeColor
}) => {
  return {
    "--icon-color": state === "active" ? activeColor : color,
    "--icon-active-color": state === "disabled" || !activeColor ? color : activeColor
  };
};

// src/Wrappers/IconWrapper.tsx
var import_jsx_runtime2 = require("react/jsx-runtime");
var getWrapperStyles = (props) => ({
  ...getIconBaseCssVariables(props),
  ...getIconColoringCssVariables(props)
});
var IconWrapper = (props) => {
  return /* @__PURE__ */ (0, import_jsx_runtime2.jsx)(
    "div",
    {
      className: "ui-icon-size-wrapper ui-icon-coloring-wrapper",
      style: getWrapperStyles(props),
      children: props.children
    }
  );
};

// src/icons/monochrome/IconEyeOpened.tsx
var import_jsx_runtime3 = require("react/jsx-runtime");
var IconEyeOpened = (props) => {
  return /* @__PURE__ */ (0, import_jsx_runtime3.jsx)(IconWrapper, { ...props, children: /* @__PURE__ */ (0, import_jsx_runtime3.jsx)(eyeOpened_default, {}) });
};
IconEyeOpened.displayName = "IconEyeOpened";
var IconEyeOpened_default = IconEyeOpened;
